export default __webpack_public_path__ + "a1f6be08364ba19d716f83e063d505c1.png";